const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 14.5,
  cy: 4.5,
  r: 1.5
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 14.5,
  cy: 9.5,
  r: 1.5
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 1.5
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 14.5,
  cy: 19.5,
  r: 1.5
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.5,
  cy: 4.5,
  r: 1.5
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 1.5
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.5,
  cy: 14.5,
  r: 1.5
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 9.5,
  cy: 19.5,
  r: 1.5
});

const SvgDrag = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drag.fd3eef48.svg";
export { ForwardRef as ReactComponent };